import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInfoService } from '@shared/services/common/app-info.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  private apiUrl = '/api/user/change-password'; // API endpoint

  constructor(private http: HttpClient, public appInfo: AppInfoService) { }

  changePassword(newPassword: string, token: string, email: string): Observable<any> {
    const body = {
      NewPassword: newPassword,
      ConfirmPassword: newPassword,
      Email: email,
      Token: token 
    };
    return this.http.post(this.appInfo.appUrl + 'api/user/change-password', body, this.appInfo.httpOptions);
  }
  forgotPassword(email: string): Observable<any> {
    const model = { Email: email };
    return this.http.post<any>(this.appInfo.appUrl + `api/user/forgot-password`, model, this.appInfo.httpOptions);
  }
  getPasswordPeriod(userId) {
    return this.http.post<any>(this.appInfo.appUrl + `api/user/getpasswordperiod?userId=` + userId, this.appInfo.httpOptions);
  }
}
